import { CaseDelay } from "us.collection.case/constants/Actions";
import { IAPIAction } from "us.collection/interfaces";

export const CaseDelayAction: Readonly<IAPIAction> = {
  /**
   * @namespace delay
   */
  delay: {
    save: (data) => ({
      type: CaseDelay.SAVE_CASE_DELAY_START,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: CaseDelay.SAVE_CASE_DELAY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: CaseDelay.SAVE_CASE_DELAY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
